const context = 'reports'

export const GET_REPORTS_SUCCEEDED = `${context}/GET_REPORTS_SUCCEEDED`
export const GET_REPORTS_REQUESTED = `${context}/GET_REPORTS_REQUESTED`
export const GET_REPORTS_FAILED = `${context}/GET_REPORTS_FAILED`

export const SET_SELECTED_REPORT_ID = `${context}/SET_SELECTED_REPORT_ID`
export const GET_CURRENT_URL = `${context}/GET_CURRENT_URL`
